/* eslint-disable no-console */
import { useState } from "react";
import { getNestedValue } from "@swiggy-private/js-utils";
import { isEmpty } from "@swiggy-private/js-utils";
import WebBridgeSdk from "utils/webBridgeSdk";
import { useEffectOnce } from "./useEffectOnce";

const getConfigValue = async (key: string) => {
    const payload = {
        xpKeyList: [key],
        wpKeyList: [key],
    };

    return WebBridgeSdk?.getInstance()
        ?.getConfigValue(payload)
        .then((res) => res ?? {})
        .catch(() => ({}));
};

export const usePublicApiConfig = () => {
    const [enablePublicApi, setEnablePublicApi] = useState(false);

    useEffectOnce(() => {
        const fetchConfig = async () => {
            try {
                const configs = await getConfigValue("cw_public_endpoint_config");
                const wpValue = getNestedValue(configs, "wpValues.cw_public_endpoint_config", "");
                if (isEmpty(wpValue)) {
                    setEnablePublicApi(false);
                    return;
                }

                const parsedConfig = JSON.parse(wpValue);
                setEnablePublicApi(parsedConfig?.enable_public_api_swiggy_one === "true");
            } catch {
                setEnablePublicApi(false);
            }
        };
        fetchConfig();
    });
    return { enablePublicApi };
};
